import Vapi from "vuex-rest-api";
import { API_URL } from "../config";

const elements = new Vapi({
  baseURL: API_URL,
  state: {
    elements: []
  }
})
  .get({
    action: "getElements",
    property: "elements",
    path: "/elements"
  })
  .getStore();

export default elements;
